/*
* System
* 장비 관리
* ZTP 토큰
*
*
* @since 2022-11-14
* @author wj_tams_dev01
* */

import {SystemApiPrefix} from '~/utils/restApi'

const urlPrefix = `${SystemApiPrefix}/ztp/token`

export const state = () => ({
  ztpTokenList: [], // ZTP 토큰 리스트
  ztpDeviceList: [] // ZTP 장비 리스트
})

export const mutations = {
  init (state) {
    state.ztpTokenList = []
    state.ztpDeviceList = []
  },

  initZtpTokenList (state, ztpTokenList) {
    if (_.isArray(ztpTokenList)) {
      state.ztpTokenList = ztpTokenList
    } else {
      state.ztpTokenList = []
    }
  },
  initZtpTokenDeviceList (state, ztpDeviceList) {
    if (_.isArray(ztpDeviceList)) {
      state.ztpDeviceList = ztpDeviceList
    } else {
      state.ztpDeviceList = []
    }
  }
}

export const actions = {

  /* ZTP 토큰 목록 조회 */
  async getZtpTokenList ({commit}, {param, loading = true} = {}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isNumber(param.device_id)) {
      res = {code: 'nok', reason: 'device_id is null'}
      return res
    }
    const urlZtpToken = `${SystemApiPrefix}/devices/${param.device_id}/ztp/token`
    try {
      const {code, result} = await this.$axios.$get(urlZtpToken, {loading})
      if (code === 'ok') {
        commit('initZtpTokenList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 생성 */
  async createZtpToken ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isNumber(param.device_id) || param.device_id <= 1) {
      res = {code: 'nok', reason: 'deviceId is null'}
      return res
    }
    const urlZtpToken = `${SystemApiPrefix}/devices/${param.device_id}/ztp/token`
    try {
      const {code, result} = await this.$axios.$post(urlZtpToken, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 편집 */
  async editZtpToken ({state}, {param}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isString(param.token_id)) {
      res = {code: 'nok', reason: 'token is null'}
      return res
    }
    const urlZtpToken = `${urlPrefix}/${param.token_id}`
    try {
      const {code, result} = await this.$axios.$put(`${urlZtpToken}`, {desc: param.desc, volume_of_devices: param.volume_of_devices}, {successAlert: false, loading: false})
      if (code !== 'ok') {
        if (result.msg === undefined) {
          res = {code: 'nok', reason: '', result: result}
        } else {
          res = {code: 'nok', reason: result.msg, result: result}
        }
      } else {
        res = {code: 'ok', result: result}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 삭제 */
  async delZtpToken ({state}, {param}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isString(param.token_id)) {
      res = {code: 'nok', reason: 'token is null'}
      return res
    }
    const urlZtpToken = `${urlPrefix}/${param.token_id}`
    try {
      const {code, result} = await this.$axios.$delete(`${urlZtpToken}`, {successAlert: false, loading: false})
      if (code !== 'ok') {
        if (result.msg === undefined) {
          res = {code: 'nok', reason: '', result: result}
        } else {
          res = {code: 'nok', reason: result.msg, result: result}
        }
      } else {
        res = {code: 'ok', result: result}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 장비 목록 조회 */
  async getZtpTokenDeviceList ({commit}, {param, loading = true} = {}) {
    let res = {code: 'ok'}
    if (!_.isPlainObject(param) || !_.isString(param.token_id)) {
      res = {code: 'nok', reason: 'token is null'}
      return res
    }
    const urlZtpToken = `${urlPrefix}/${param.token_id}/devices`
    try {
      const {code, result} = await this.$axios.$get(urlZtpToken, {loading})
      if (code === 'ok') {
        commit('initZtpTokenDeviceList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* ZTP 토큰 적용/취소 */
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/${type}`,
      axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = {code: 'nok', result: {msg: e}}
    }
    return res
  }
}
